export const PDF_IMAGE_REPLACEMENT: string = '[#packoutimageurl#]';
